import { Carrier } from '@liveauctioneers/hammer-ui-payments/types';

export enum ShippingVisibility {
    Pending = 'pending',
    Unavailable = 'disabled',
    Uncalculated = '',
    Visible = 'enabled',
}

export const IN_HOUSE_SHIPPING_SINGLE_REGION_COUNT = 1;
export const IN_HOUSE_SHIPPING_TWO_REGIONS_COUNT = 2;
export const IN_HOUSE_SHIPPING_THREE_REGIONS_COUNT = 3;
export const ALL_IN_HOUSE_SHIPPING_REGION_COUNT = 4;

export enum InHouseShippingRangeRegions {
    Canada = 'Canada',
    Europe = 'Europe',
    UnitedKingdom = 'United Kingdom',
    UnitedStates = 'Continental United States',
    Worldwide = 'Worldwide',
}

export type InHouseShippingRangeEstimates = {
    houseId: number;
    catalogId: number;
    lowCost: number;
    highCost: number;
    currency: string;
    regions: InHouseShippingRangeRegions[];
};

export type ShippingEstimate = {
    actualHandlingAndInsurance: number;
    /**
     * This amount is the shipping fee total, regardless of what the house charges the winning bidder
     * @see {actualHandlingAndInsurance}
     */
    actualTotal: number;
    carrierName: Carrier;
    carrierService: string;
    city: string;
    currency: string;
    /**
     * true if elabel
     *
     * false if full-service
     */
    elabel: boolean;
    expirationDate: string;
    /**
     * Handling and Insurance is an additional fee applied to USPS quotes
     */
    handlingAndInsurance: number;
    /**
     * Is the returned quote flat-rate shipping?
     * Can only be true for elabel estimates
     */
    isFlatRate: boolean;
    /**
     * This is only returned for in-house shipping, not LiveShipping
     */
    inHouseRange?: InHouseShippingRangeEstimates;
    message: string;
    quoteId: string;
    quoteNumber: string;
    shippingAvailable: boolean;
    shippingProvider: number;
    state: string;
    /**
     * The amount a bidder will pay if they win (does not include handling and fees)
     * @see {handlingAndInsurance}
     */
    total: number;
    transitDays: number;
    visibility: ShippingVisibility;
};
